/**
 * Home Routes
 */
import React from 'react';
import { createRoute, redirect } from '@tanstack/react-router';
import { authLayoutRoute } from '../rootRoute';

const Home = React.lazy(() => import('../../pages/Home/Home'));

/**
 * Index redirect - /bbweb → /bbweb/home
 */
export const bbwebIndexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/bbweb/home' });
  },
});

/**
 * Home page
 */
export const homeRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/home',
  component: Home,
});

export const homeRoutes = [bbwebIndexRoute, homeRoute];
